"use strict";
"use es6";
// typeof any so that it we don't have to cast when comparing a result to the error object

Object.defineProperty(exports, "__esModule", {
  value: true
});
var errorObject = exports.errorObject = { e: {} };


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/errorObject.js
// module id = 152
// module chunks = 177